import { z } from 'zod';
import { AuditMeta, DocId, TenantId } from '../common.js';
/**
 * Taxonomy node. Categories form a tree (parentId → null for roots).
 * Spec top-level split: `Klinische onderwerpen` vs `Interne documenten`.
 *
 * Firestore path: categories/{categoryId}
 */
export const CategorySchema = AuditMeta.extend({
    id: DocId,
    tenantId: z.union([TenantId, z.literal('_platform')]),
    name: z.string().min(1).max(200),
    slug: z
        .string()
        .min(1)
        .max(200)
        .regex(/^[a-z0-9-]+$/, 'Slug must be lowercase alphanumeric with hyphens'),
    parentId: DocId.nullable(),
    /**
     * Top-level domain — affects which agents retrieve against this category.
     */
    domain: z.enum(['clinical', 'internal', 'sociale_kaart']),
    documentCount: z.number().int().nonnegative().default(0),
});
export const CreateCategoryInput = CategorySchema.pick({
    name: true,
    slug: true,
    parentId: true,
    domain: true,
});
/**
 * Merge operation payload. Both categories must exist in the same tenant + domain.
 * All documents in `sourceId` move to `targetId`; `sourceId` is then deleted.
 */
export const MergeCategoriesInput = z.object({
    sourceId: DocId,
    targetId: DocId,
});
//# sourceMappingURL=category.js.map